import { RouteDataFuncArgs, useNavigate, useParams, useRouteData } from "@solidjs/router";
import { Show, VoidComponent } from "solid-js";
import { z } from "zod";
import EditClientForm from "~/components/EditClientForm";
import PageSection from "~/components/PageSection";
import { createQuery } from "~/components/RPCProvider";
import { routeData as dashboardRouteData } from "~/routes/dashboard";

export const routeData = ({data, params}: RouteDataFuncArgs) => {
	const input = routeParams.parse(params);
	const [accountInfo] = data as ReturnType<typeof dashboardRouteData>;

	return {
		results: createQuery("getClient", input),
		accountInfo
	}
};

const routeParams = z.object({
	clientId: z.string().uuid()
});

export const EditClientPage: VoidComponent = () => {
	const { results, accountInfo } = useRouteData<typeof routeData>();
	const params = useParams();
	const navigate = useNavigate();
	const { clientId } = routeParams.parse(params);

	return (
		<PageSection>
			<Show when={accountInfo() && results[0].latest?.results} fallback="Loading...">
				<EditClientForm
					onSuccess={(client) => {
						navigate("/dashboard/clients");
					}}
					clientId={clientId}
					client={assert(results[0].latest).results}></EditClientForm>
			</Show>
		</PageSection>
	);
};
export default EditClientPage;
function assert<T>(expression: T): NonNullable<T> {
  if (expression === undefined) {
    throw new Error("unexpected undefined value ");
  }
  if (expression === null) {
    throw new Error("unexpected null value ");
  }
  return expression;
}
